import {
  CHECK_IF_CUSTOMER_EXISTS,
  DELETE_CUSTOMER,
  FETCH_CUSTOMERS,
  FETCH_RECENT_TICKETS,
  INTERNAL_UPDATE_CUSTOMER,
  POST_CUSTOMER_CREATION_TICKET,
  receiveCustomers,
  receiveRecentTickets,
} from "@/components/customer/internal/ducks/Actions"
import {
  apiCheckIfCustomerExists,
  apiDeleteCustomer,
  apiFetchCustomers,
  apiFetchRecentTickets,
  apiInternalUpdateCustomer,
  apiPostCustomerCreationTicket,
} from "@/components/customer/internal/ducks/AJAX"

export default () => (next) => (action) => {
  switch (action.type) {
    case FETCH_RECENT_TICKETS:
      apiFetchRecentTickets(receiveRecentTickets)
      return next(action)

    case DELETE_CUSTOMER:
      apiDeleteCustomer(action.success, action.error)
      return next(action)

    case CHECK_IF_CUSTOMER_EXISTS:
      apiCheckIfCustomerExists(action.success, action.error)
      return next(action)

    case POST_CUSTOMER_CREATION_TICKET:
      apiPostCustomerCreationTicket(action.params, receiveRecentTickets, null, action.success)
      return next(action)

    case INTERNAL_UPDATE_CUSTOMER:
      apiInternalUpdateCustomer(
        action.customerId,
        action.params,
        receiveCustomers,
        action.error,
        action.success,
      )
      return next(action)

    case FETCH_CUSTOMERS:
      apiFetchCustomers(receiveCustomers, action.error, action.success)
      return next(action)

    default:
      return next(action)
  }
}
